import { Swiper } from 'swiper';
import { A11y, EffectFade, Navigation, Pagination } from 'swiper/modules';

class Slideshow {
  private carousel: HTMLElement;
  private prevEl: HTMLElement;
  private nextEl: HTMLElement;
  private paginationEl: HTMLElement;
  private pm: any;

  constructor(carousel: HTMLElement) {
    this.carousel = carousel.querySelector('.swiper') as HTMLElement;
    this.prevEl = carousel.querySelector('[hero-carousel-prev]') as HTMLElement;
    this.nextEl = carousel.querySelector('[hero-carousel-next]') as HTMLElement;
    this.paginationEl = carousel.querySelector('[hero-carousel-pagination]') as HTMLElement;
    this.pm = (window as any).personalizationManager;

    if (this.pm) {
      this.pm.addPersonalizedContentLoaded(() => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init(): void {
    new Swiper(this.carousel, {
      modules: [A11y, EffectFade, Navigation, Pagination],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      pagination: {
        el: this.paginationEl,
        type: 'bullets',
      },
      breakpoints: {
        768: {
          pagination: {
            type: 'fraction',
          },
        },
      },
    });
  }
}

document.querySelectorAll('[hero-carousel]').forEach((slider) => {
  new Slideshow(slider as HTMLElement);
});
